/**
 * Tasks Service - Public API
 *
 * Handles task scheduling and ordering for matters.
 * Tasks represent when to work on a matter (Today, Upcoming, etc.)
 *
 * Exports the public interface for the task management service.
 * Mock data is intentionally not exported to keep it internal.
 */

export * from './types';
export * from './hooks';
